import React from 'react';
import '../Playlists.css';

const playlists = [
  { title: 'Hits 2024', cover: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80', tracks: 18 },
  { title: 'Chill & Relax', cover: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80', tracks: 12 },
  { title: 'Electro Party', cover: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80', tracks: 22 },
];

export default function Playlists() {
  return (
    <div className="playlists-root">
      <h1>Mes playlists</h1>
      <div className="playlists-list">
        {playlists.map((p, i) => (
          <div className="playlists-card" key={i}>
            <img className="playlists-cover" src={p.cover} alt={p.title} />
            <div className="playlists-info">
              <strong>{p.title}</strong>
              <span>{p.tracks} morceaux</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 